export enum IconSize {
  xSmall = 'xSmall',
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export const ICON_SIZE_X_SMALL = '12px'
export const ICON_SIZE_SMALL = '16px'
export const ICON_SIZE_MEDIUM = '20px'
export const ICON_SIZE_LARGE = '32px'

export const getIconSize = (size: IconSize | number) => {
  if (typeof size === 'number') {
    return `${size}px`
  }

  switch (size) {
    case IconSize.xSmall:
      return ICON_SIZE_X_SMALL
    case IconSize.medium:
      return ICON_SIZE_MEDIUM
    case IconSize.large:
      return ICON_SIZE_LARGE
    default:
      return ICON_SIZE_SMALL
  }
}
